module.exports = __webpack_public_path__ + "static/media/cash.54ae7c17.jpg";